import { OpenAPI } from '@puppet/cd4pe-client-ts';

export default async function withPollingHeader<T>(
  fn: () => Promise<T>,
): Promise<T> {
  const headers = OpenAPI.HEADERS;
  if (typeof headers === 'object' && headers !== null) {
    (headers as Record<string, string>)['X-Polling-Request'] = 'true';
  } else {
    OpenAPI.HEADERS = { 'X-Polling-Request': 'true' };
  }
  try {
    return await fn();
  } finally {
    if (typeof OpenAPI.HEADERS === 'object' && OpenAPI.HEADERS !== null) {
      delete (OpenAPI.HEADERS as Record<string, string>)['X-Polling-Request'];
    }
  }
}
